import * as types from './types';

export const setModalData = payload => ({
  type: types.SET_MODAL_DATA,
  payload,
});

export const setEditableItem = payload => ({
  type: types.SET_EDITABLE_ITEM,
  payload
});

export const getCategories = payload => ({
  type: types.GET_CATEGORIES_REQUEST,
  payload,
});

export const setCurrentRestaurant = payload => ({
  type: types.SET_CURRENT_RESTAURANT,
  payload,
});

export const getStripeLink = () => ({
  type: types.GET_STRIPE_LINK_REQUEST,
});

export const resetState = () => ({
  type: types.RESET_STORE,
});
